import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button, Field } from "../components/ui";
import { Icon } from "../components/icons";

export default function Password() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 6) return setError("A nova palavra-passe deve ter pelo menos 6 caracteres.");
    if (next !== confirm) return setError("As palavras-passe não coincidem.");
    setBusy(true);
    try {
      await api("/auth/password", { method: "POST", body: JSON.stringify({ current_password: current, new_password: next }) });
      setOk(true);
      setTimeout(() => navigate(-1), 1200);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div className="page-header" style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <button className="icon-btn" onClick={() => navigate(-1)}><Icon name="chevron-back" size={22} /></button>
        <h1 className="t-h1" style={{ fontSize: 26 }}>Alterar palavra-passe</h1>
      </div>
      <form onSubmit={submit} className="page ulc-fade" style={{ maxWidth: 520, display: "flex", flexDirection: "column", gap: 16 }}>
        <Field label="PALAVRA-PASSE ATUAL" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="password-current" autoComplete="current-password" />
        <Field label="NOVA PALAVRA-PASSE" type="password" value={next} onChange={(e) => setNext(e.target.value)} placeholder="Mínimo 6 caracteres" data-testid="password-new" autoComplete="new-password" />
        <Field label="CONFIRMAR NOVA PALAVRA-PASSE" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="password-confirm" autoComplete="new-password" />
        {error ? <div style={{ background: "var(--error)", color: "var(--on-error)", padding: 12, borderRadius: "var(--r-md)", fontSize: 13 }} data-testid="password-error">{error}</div> : null}
        {ok ? <div style={{ background: "var(--success)", color: "var(--on-success)", padding: 12, borderRadius: "var(--r-md)", fontSize: 13 }}>Palavra-passe alterada com sucesso.</div> : null}
        <Button type="submit" loading={busy} data-testid="password-submit">GUARDAR</Button>
      </form>
    </>
  );
}
